module.exports = __webpack_public_path__ + "static/media/earth_edge.1dcedad3.jpg";